import React from 'react';

import Grid from '@material-ui/core/Grid';

import { BarChart, Bar, Tooltip, XAxis, YAxis } from 'recharts';

class BarChartComponent extends React.Component {

    render() {

        return (
            <Grid container direction="row"
            justifyContent="center" alignItems="center">
                <BarChart width={950} height={500} data={this.props.data}>
                    <XAxis angle={-5} dataKey="Time" />
                    <YAxis domain={['dataMin - 1.21', 'dataMax']} />
                    <Tooltip />
                    <Bar dataKey="Value" fill="#8884d8" />
                </BarChart>
            </Grid>
        )
    }
}

export default BarChartComponent;